import React from 'react';
import T from 'i18n-react';

import DropDown, { DropDownPropTypes } from './components/DropDown';

const PriorityDropDown = ({ ...restProps }) => (
  <DropDown
    {...restProps}
    label={T.translate('new.priority')}
    valueKey="key"
    placeholder={T.translate('filter.priority')}
  />
);

// eslint-disable-next-line no-unused-vars
const { label, placeholder, valueKey, searchIcon, ...PriorityDropDownPropTypes } = DropDownPropTypes;

PriorityDropDown.propTypes = PriorityDropDownPropTypes;
export default PriorityDropDown;
